import Box from '@mui/material/Box'
import { keyframes } from '@mui/system'
import logo from '../assets/images/logo.svg'

const fade = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
`

export default function AppLoader() {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        component='img'
        src={logo}
        alt='Loading...'
        sx={{
          width: '25rem',
          height: 'auto',
          animation: `${fade} 2s ease-in-out infinite`
        }}
      />
    </Box>
  )
}
